var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 17.5C10.8284 17.5 11.5 16.8284 11.5 16V11.5H16C16.8284 11.5 17.5 10.8284 17.5 10C17.5 9.17158 16.8284 8.5 16 8.5H11.5V4C11.5 3.17157 10.8284 2.5 9.99999 2.5C9.17156 2.5 8.49999 3.17157 8.49999 4L8.49999 8.5H4C3.17157 8.5 2.5 9.17158 2.5 10C2.5 10.8284 3.17157 11.5 4 11.5H8.49999L8.49999 16C8.49999 16.8284 9.17157 17.5 9.99999 17.5Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGrey);
export default __webpack_public_path__ + "static/media/add-grey.d46ee5ec.svg";
export { ForwardRef as ReactComponent };